import { render, staticRenderFns } from "./GlofasProfile.vue?vue&type=template&id=417d9611&scoped=true&"
import script from "./GlofasProfile.vue?vue&type=script&lang=js&"
export * from "./GlofasProfile.vue?vue&type=script&lang=js&"
import style0 from "./GlofasProfile.vue?vue&type=style&index=0&id=417d9611&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417d9611",
  null
  
)

export default component.exports